<nb-icon [icon]="iconName()" pack="eva" [status]="color()"></nb-icon>
